export class ALL_CLIENT_CODE {
    static MF = "mf";
    static AZ = "az";
}
export class PATHNAME {
    ///userRegistration
    static USERS = "/users";
    static MANAGE_USERS = "/users/manage/all";
    static ADD_USER = "/users/manage/new";
    static USER_STATUS = "/users/manage/status";
    static ROLES_PERMISSIONS = '/users/manage/permissions';
    ///Agent Reg
    static AGENT_REGISTRATION = "/agent_registration";
    // static AGENT_REG = '/agent_reg';
    static APPROVE_AGENT = "/agent_registration/approve_agent";
    static MANAGE_AGENT = '/agent_registration/manage_agents';
    static MANAGE = '/agent_registration/manage_agents/manage';
     ///CRS
    static CONTRACT_ALL = "/crs/contract";
    static CONTRACT_NEW = "/crs/contract/new";
    static SCHEDULE_ALL = "/crs/flight/schedule/all";
    static SCHEDULE_NEW = "/crs/flight/schedule/new";
    static FARE_UPLOAD_ALL = "/crs/flight/fareupload/all";
    static FARE_UPLOAD_NEW = "/crs/flight/fareupload/new";
    static FARE_RULE_ALL = "/crs/flight/farerule/all";
    static FARE_RULE_NEW = "/crs/flight/farerule/new";
    static TAX_SETUP = "/crs/tax/new";
    static TAX_ALL = "/crs/tax/all";
    static FARE_VIEW = "/crs/flight/fareview";
    static BOOKING_MANIFEST_REPORT = "/crs/report/manifest"
    static BOOKING_LIST_REPORT = "/crs/report/booking"
    static FLIGHT_LOAD_FACTOR_REPORT = "/crs/report/load"
    static GUIDE = "/help/guide";


    static INITIAL_PATH="/";

    ///Common
    static DASHBOARD = "/#/";
    // static HOME = "/home";
    static PAGES = "/pages";
    static PAGE_404 = "/pages/404";
    static PAGE_500 = "/pages/500"
    static ROUTE = "/tools/route";
    static PAXPAGE = "/booking/flight/pax_page";
    //static SEARCHPAGE = "/search_page";
    static DASHBOARD = "/dashboard";
    static CHANGE_PASSWORD = "/change_password";

    //Tools
    static TOOLS = '/tools'
    static EXCHANGE_RATE = "/tools/payment/exchange_rate";
    static PAYMENT_SETUP = '/tools/payment/setup';
    static ADD_PAYMENT = '/tools/payment/setup/new';
    static PAYMENT_FEE = '/tools/payment/setup/new/fee';
    static ROUTES = '/tools/routes';
    static CLASSES = "/tools/classes";
    static CURRENCY = '/tools/currency';
    static STATE_PROVINCE = '/tools/state';
    static EXTENSION_SETUP = '/tools/paymentextension';
    static NOTIFICATION_SETUP = '/tools/notification_setup';
    static MANAGE_ORG='/tools/organize/all';

    //Note
    static CREDIT_NOTE = "/credit";
    static CREDIT = "/credit/credit_note";
    static CREDIT_REPORT = '/credit/credit_report';
    static DEBIT = '/debit';
    static DEBIT_NOTE = "/debit/debit_note";
    static DEBIT_REPORT = '/debit/debit_report';
    static REPORT = "/report";

    //Login
    static SYSTEM_LOGIN = "/system_login";
    static AGENT_LOGIN = "/agent_login";
    //pricing
    static PRICING = "/pricing";
    static CHANGE_PRICING = "/pricing/change_pricing";
    static MANAGE_PRICING = "/pricing/setup/manage";
    static SETUP_PRICING = '/pricing/setup';
    static CREATE_PRICING = '/pricing/create_pricing';
    static ASSIGN_PRICING = '/pricing/assign/all';
    static ADD_NEW_PRICING = '/pricing/assign/new';
    static MANAGE_SIMPLE_PRICING = "/pricing/simple/setup/manage";
    static  CREATE_SIMPLE_PRICING ='/pricing/simple/create_pricing'

    ///Top Up

    static TOPUP = "/agent/prepaid/topup";
    static SYSTEM_TOPUP = "/system_topup";
    static TOPUP_REPORT = "/topup/report";

    ///Booking

    static BOOKING_DETAILS='/booking/flight/my_booking/detail'
    static BOOKING = "/booking";
    static FLIGHTSEARCH = "/booking/flight/search";
    static FLIGHTRESULTS = "/booking/flight/result";
    static HOTEL_RESULT = "/booking/hotel/result";
    static HOTEL_ROOM_RESULT = "/booking/hotel/result/room";
    static GUEST_PAGE = "/booking/hotel/guest_page";
    static HOTEL_PAYMENT_PAGE = "/booking/hotel/payment";

    static TOUR_FLIGHT_RESULTS = "/tour/booking/flight/result";
    static TOUR_ML_FLIGHT_RESULTS = "/tour/booking/flight/multiCity/result";
    static PAYMENTPAGE = "/booking/flight/payment";
    static BOOKING_STATUS = "/booking/flight/booking_status";
    static HOLDPAGE = "/booking/flight/status/hold";
    static SUCCESSPAGE = "/booking/flight/status/success";
    static PENDINGPAGE = "/booking/flight/status/pending";
    static FAILEDPAGE = "/booking/flight/status/failed";
    static PAYMENTGATEWAY = "/payment/processpayment/entry";
    static TICKET_NOW = "/booking/flight/ticketing_queue/ticketnow";
    static ML_FLIGHTRESULTS = "/booking/flight/multiCity/result";
    static SYSTEM_TICKET_NOW = "/booking/flight/ticketing_queue/system/ticketnow"
    static TEST_FLIGHT_RESULTS = "/booking/flight/result/test";



    static REFUND = "/booking/flight/manage/refund";
   static  EXCHANGE ='/booking/flight/manage/exchange'
   

        
    static  ALL_EXCHANGE="/booking/flight/manage/exchange/all";
    static  EXCHANGE_DET="/booking/flight/manage/exchange/details"


    static  ALL_REFUND="/booking/flight/manage/refund/all";
    static  REFUND_DET="/booking/flight/manage/refund/details"


    static MY_BOOKING = "/booking/flight/my_booking";
    static TICKETING_QUEUE = "/booking/flight/ticketing_queue";
    static MY_BOOKING_DETAIL = "/booking/flight/my_booking/my_booking_detail";
    static TICKETING_QUEUE_DETAIL = "/booking/flight/ticketing_queue/ticketing_detail";


    ///Postpaid
    static POSTPAID = '/postpaid';
    static DEPOSIT = '/postpaid/deposit';
    static PENDING_INVOICES = '/postpaid/invoices/pending';
    static VIEW_STATEMENTS = '/postpaid/statements';
    static RESET_PASSWORD = '/reset_password'
    static AGENT_DEPOSIT = '/agent/postpaid/deposit'
    static AGENT_VIEW_STATEMENTS = '/agent/postpaid/statements'
    static AGENT_DEPOSIT_PAY = '/agent/postpaid/deposit/pay'

    static PAYMENT_STATUS = '/payment/payment_status';
    static SUCCESS_PAY = '/payment/status/success';
    static FAILED_PAY = '/payment/status/failed';
    static PENDING_PAY = '/payment/status/pending';

    static SYSTEM_REPORT ='/system/report';
    static AGENT_PREPAID_REPORT ='/prepaid/report';
    static AGENT_PREPAID_SUMMARY ='/prepaid/summary';
    static AGENT_POSTPAID_REPORT ='/postpaid/report';
    static AGENT_POSTPAID_SUMMARY ='/postpaid/summary';
    static BOOKING_REPORT ='/booking/report';
    static TOPUP_FORECAST_REPORT ='/topup/forecast/report';
    static DAILY_OR_PERIODICAL_SALES_REPORT ='/periodical/sales/report';
    static PERIODICAL_SALES_DETAIL_REPORT ='/periodical/sales/detail/report';
    static TOPUP_PROJECTION_REPORT='/topup/projection/report'
    static CREDIT_SALES_REPORT="/credit/sales/report"
    ///mobile
    static APROFILE = '/profile'
    ///Agentgroup
    static AGENTGROUP_ALL = '/agentgroup/all';
    static AGENTGROUP_NEW = '/agentgroup/new';

    static ADD_PROFILE = '/smallagent/add';
    static PROFILE_LIST = '/smallagent/list';
    static PAYMENT_RECEIVED = '/smallagent/list/pay';

    static SUPPLIER_GROUP_ALL = '/hms/supplier/group/all'
    static SUPPLIER_GROUP_NEW = '/hms/supplier/group/new'
    static MANAGE_ALL = '/hms/manage/all'
    static HOTEL_INFO='/hms/manage/hotelinfo'
    static MANAGE_HOTEL_NEW = '/hms/manage/new'
    static TARIFF_ALL = '/hms/manage/hotelinfo/tariff/all'
    static RATE_PLAN_ALL = '/hms/manage/hotelinfo/rateplan/all'
    static CANCELLATION_ALL = '/hms/manage/hotelinfo/cancellation/all'
    static SURCHARGE_ALL = '/hms/manage/hotelinfo/surcharge/all'

    static TARIFF_NEW = '/hms/manage/hotelinfo/tariff/new'
    static RATE_PLAN_NEW = '/hms/manage/hotelinfo/rateplan/new'
    static CANCELLATION_NEW = '/hms/manage/hotelinfo/cancellation/new'
    static SURCHARGE_NEW = '/hms/manage/hotelinfo/surcharge/new'
    static HOTEL_TAX_NEW='/hms/manage/hotelinfo/tax/new'
    static HOTEL_ROOM_SETUP='/hms/manage/hotelinfo/room/new'
    static HOTEL_USERS_NEW='/hms/user/new'
    static HOTEL_USERS_ALL='/hms/user/all'
    static MARKUP_ALL='/hms/markup/all'
    static MARKUP_NEW='hms/markup/new';
    static ALL_HOTEL_TAX_SETUP='/hms/tax/setup';
 
    

}

export class FLIGHT_SELECTION_STATUS {
    static noClass = 0;
    static selected = 1;
    static selectable = 2;
    static disable = 3;
}


export class COMPONENT_NAME {
    static MANAGE_ORG='ManageOrg'
    static C_HOTEL_THUMBNAIL='cHotelThumbnail'
    static C_WEEK_DAYS='cWeekDays'
    static C_HOTEL_AVAILABILITY='cHotelAvailability'
    static  MANAGE_SIMPLE_PRICING ='ManageSimplePricing'
    static C_AVAILABILITY='cAvailability'
    static C_AVAILABILITY_LOADER='cAvailabilityLoader'
    static C_AVAILABILITY_CALENDER = 'cAvailabiltyCalender'
    static C_GUEST_AGE_SETUP = 'cGuestAgeSetup';
    static C_AVAIL_PRICE_MODAL = 'cAvailPriceModal'
    static C_SURCHARGE_SETUP='cSurchargeSetup'
    static C_HOTEL_ERROR_CARD='cHotelErrorCard'
    static C_HOTEL_ERRORS='cHotelErrors'
    static ALL_HOTEL_TAX_SETUP='AllHotelTaxSetup'
    static HOTEL_ROOM_SETUP='HotelRoomSetup'
    static C_HOTEL_ROOM_NEW='cHotelRoomNew'
    static  C_SWAP_MODAL_PAGE =  'cSwapModalPage'
    static  HOTEL_TAX_NEW='HotelTaxNew'
    static C_ALL_HOTEL_TAX='cAllHotelTax'
    static C_HOTEL_TAX_SETUP='cHotelTaxSetup'
    static C_ROOM_TYPE_INFO='cRoomTypeInfo'
    static C_HOTEL_SURCHARGES='cHotelSurcharges' 
    static C_BED_TYPES='cBedTypes'
    static C_ROOM_LANG='cRoomLang'  
    static C_ROOM_AMENITIES='cRoomAmenities'
    static C_ROOM_RATE_PLANS='cRoomRatePlans'
    static C_HOTEL_ROOM_DET='cHotelRoomDet'
    static C_HOTEL_AMENITIES='cHotelAmenities'
    static C_HOTEL_LANG='cHotelLang'
    static C_COMMON_FUNC='cCommonFunc';
    static C_SPORTS_ENTERN='cSportsEntern'
    static C_ALERT_SETUP='cAlertSetup'
    static C_AGE_SETUP='cAgeSetup';
    static C_HELPFUL_FACTS = 'cHelpfulFacts';
    static C_HOTEL_MAPPING = 'cHotelMapping'
    static C_LOCATION = 'cLocation';
    static C_HOTEL_IMAGES = 'cHotelImages';
    static C_ROOM_IMAGES = 'cRoomImages';
    static C_IMAGES = 'cImages';
    static C_CONTENT_EDIT= 'cContentEdit'
    static BOOKING_DETAILS='BookingDetails'
    static HOTEL_INFO='HotelInfo'
    static C_EXPORT_EXCEL='cExportExcel'
    static  C_EDIT_TICKETS ='cEditTickets'
    static  REFUND_DET ='RefundDetails'
    static ALL_REFUND ='AllRefund'
    static SYSTEM_REPORT ='SystemReport'
    static AGENT_PREPAID_REPORT='AgentPrepaidReport'
    static C_REPORT ='cReport'
    static AGENT_PREPAID_SUMMARY='AgentPrepaidSummary'
    static AGENT_POSTPAID_SUMMARY='AgentPostpaidSummary'
    static AGENT_POSTPAID_REPORT='AgentPostpaidReport'
    static BOOKING_REPORT='BookingReport'
    static TOPUP_FORECAST_REPORT='TopupForecastReport'
    static DAILY_OR_PERIODICAL_SALES_REPORT='DailyOrPeriodicalSalesReport'
    static PERIODICAL_SALES_DETAIL_REPORT='PeriodicalSalesDetailReport'
    static TOPUP_PROJECTION_REPORT='TopupProjectionReport'
    static CREDIT_SALES_REPORT='CreditSalesReport'

    static ALL_EXCHANGE ='AllExchange'
    static EXCHANGE_DET ='ExchangeDetails'
    static C_MANAGE_COLUMNS="cManageColumns";

    static C_EDIT_FLIGHT="cEditFlight"
    static C_EDIT_PASSN="cEditPassn";
    static UPLOAD_EXCEL = 'uploadExcel';
    static C_AGENT_DASHBOARD = 'cAgentDashboard';
    static C_SYS_DASHBOARD = 'cSysDashboard';
    static C_AGT_DB_BOOKING_NUM = 'cAgtDBBookingNo';
    static C_AGT_DB_TOTAL_BOOKINGS = 'cAgtDBTotalBookings';
    static C_AGT_DB_SEARCH_COUNT = 'cAgtDBSearchCount';
    static C_AGT_DB_WEEKLY_SALES = 'cAgtDBWeeklySales';
    static C_SYS_MINI_AGT_DB = 'cSysMiniAgentDB';
    static C_SYS_TOTAL_BOOKINGS = 'cSysTotalBookings';
    static C_SYS_AGENT_SALES = 'cSysAgentSales';
    static C_SYS_BOOKING_NUMBER = 'cSysBookingNo';
    static C_SYS_SEARCH_COUNT = 'cSysSearchCount';
    static C_SYS_USER_LOGIN_ACTIVITY = 'cSysUserLoginActivity';
    static C_SYS_WEEKLY_SALES = 'cSysWeeklySale';
    static C_DP_MINI_BOOKING_LIST = 'cDPminiBookingList';
    static C_DP_TOP_CARDS = 'cDPtopCards';
    static C_DP_MINITCKT = 'cDPminiTkt';
    static C_ML_TOTAL_PRICE_INFO = 'cMLTotalPriceInfo';
    static C_ML_PER_PAX_PRICE_INFO = 'cMLPerPaxPriceInfo'
    static C_STATUS_BUTTON = 'cStatusButton'
    static C_BOOKING_PAY_LIST = 'cBookingPayList'
    static C_AGENT_DEPOSIT = 'cAgentDeposit'
    static C_SYSTEM_DEPOSIT = 'cSystemDeposit'
    static C_PAYMENT_LIST = 'cPaymentList'
    static AGENT_DEPOSIT = 'AgentDeposit'
    static PAYMENT_FEE = 'PaymentFee'
    static PAGE_404 = "Page404";
    static PAGE_500 = "Page500"
    static DASHBOARD = "DashBoard";
    static AGENT_DEPOSIT_PAY = 'AgentDepositPay'
    static EXTENSION_SETUP = 'ExtensionSetUp';
    static C_PAYMENT_TYPES = 'cPaymentTypes';
    static TOOLS = 'Tools';
    static ROUTES = 'Routes'
    static ROUTE = "Route";
    static SYSTEM_TOPUP = "SystemTopUp";
    static TOPUP_REPORT = "TopUpReport";

    static TOPUP = "TopUp";
    static PRICING = 'Pricing'
    static SETUP_PRICING = 'SetupPricing';
    static CREATE_PRICING = 'CreatePricing';
    static ASSIGN_PRICING = 'AssignPricing';
    static ADD_NEW_PRICING = 'AddNewPricing';
    static PAYMENT_SETUP = 'PaymentSetup';
    static NOTIFICATION_SETUP = 'NotificationSetUp'
    static FLIGHTRESULTS = "FlightResults";
    static HOTEL_RESULTS = "HotelResult";
    static HOTEL_ROOM_RESULTS = "HotelRoomResult";
    static TOUR_FLIGHT_RESULTS = "TourFlightResults";
    static TOUR_ML_FLIGHT_RESULTS = "TourMLFlightResult";
    static C_FLIGHTRESULTCARD = "cFlightResultCard";
    static C_SUGGFLIGHTRESULTCARD = "cSuggFlightResultCard";
    static C_RESULTCONTENTLOADER = "cResultContentLoader";
    static C_CONNECTING_FLIGHT_INFO = "cConnectingFlightInfo"
    static PAYMENTPAGE = "PaymentPage";
    static HOLDPAGE = "HoldPage";
    static FAILEDPAGE = "FailedPage";
    static SUCCESSPAGE = "SuccessPage";
    static PENDINGPAGE = "PendingPage";
    static TICKET_NOW = "TicketNow";
    static SYSTEM_TICKET_NOW = "SystemTicketNow";
    static TEST_FLIGH_RESULTS = "TestFlightResults";


    static CONTRACT_ALL = "ContractAll";
    static CONTRACT_NEW = "ContractNew";
    static FARE_RULE_ALL = "FareRuleAll";
    static FARE_RULE_NEW = "FareRuleNew";
    static FARE_UPLOAD_ALL = "FareUploadAll";
    static FARE_UPLOAD_NEW = "FareUploadNew";
    static SCHEDULE_ALL = "ScheduleAll";
    static SCHEDULE_NEW = "ScheduleNew";
    static TAX_SETUP = "TaxSetup";
    static FARE_VIEW = "FareView";
    static GUIDE = "Guide";



    static TAX_ALL = "TaxAll";

    static AGENTGROUP_ALL = "AgentGroupAll";
    static AGENTGROUP_NEW = "AgentGroupNew";
    

    static SEARCHPAGE = "SearchPage";
    static MANAGE_USERS = "ManageUsers";
    static ADD_USER = "AddUsers";
    static ROLES_PERMISSIONS = 'RolesAndPermissions';
    static USER_STATUS = "UserStatus";
    static CHANGE_PASSWORD = "ChangePassword";
    static AGENT_REGISTRATION = "AgentRegistration";
    static MANAGE_AGENT = 'ManageAgents';
    static MANAGE = 'Manage'
    static AGENT_LOGIN = "AgentLogin";
    static C_PAGINATION_LEN_OPTION = 'cPaginationLenOption';

    static EXCHANGE_RATE = "ExchangeRate";
    static CLASSES = "Classes";
    static CURRENCY = "Currency";
    static STATE_PROVINCE = "StateProvince";
    static CREDIT_NOTE = "CreditNote";
    static CREDIT = "Credit";
    static CREDIT_REPORT = "CreditReport";
    static DEBIT = 'Debit';
    static DEBIT_NOTE = "DebitNote";
    static DEBIT_REPORT = 'DebitReport';
    static REPORT = "Report";
    static PRICING = "Pricing";
    static GUEST_INFO="";
    static MANAGE_PRICING = "ManagePricing";
    //static LOGIN = "Login";
    static USERS = "Users";
    static SYSTEM_LOGIN = "SystemLogin";
    static ADD_PAYMENT = 'AddPayment'
    static PAGES = "pages"
        // static HOME = "Home";
    // static AGENT_REG = "AgentRegistration";
    static APPROVE_AGENT = "ApproveAgent";
    static C_DROPDOWN = "cDropDown";
    static C_PAX = "cPax";
    static C_CONTACT = "cContact";
    static C_PERPAXPRICE = "cPerPaxPriceInfo";
    static C_TOTALPRICE = "cTotalPriceInfo";
    static C_SELECTEDFLIGHT = "cSelFlightInfo";
    static C_MULTI_SELECTED_FLIGHT = "cMLselFlightInfo";
    static C_FLIGHTFOOTER = "cFlightFooter";
    static C_CURRENCYDP = "cCurrencyDropDown";
    static C_ORGCURRENCYDP = "cOrgCurrencyDp";
    static C_AGENT_CURRENCY = "cAgentCurrency";
    static C_REPORT_CURR_DP = "cReportCurrDp";

    static C_SEARCH_PAX = "cSearchPax";
    static PAXPAGE = "PaxPage";
    static GUEST_PAGE = "GuestPage";
    static HOTEL_PAYMENT_PAGE="HotelPaymentPage"

    static C_AGENT = "cAgent";
    static THE_HEADER_DROPDOWN_ACCNT = 'TheHeaderDropdownAccnt';
    static C_SEARCH = "cSearch";
    static C_ML_SEARCH = "cMLSearch";
    static C_ML_FLIGHTFOOTER = "cMLFlightFooter";
    static C_USER_INFO = 'cUserInfo';
    static THE_SIDEBAR='TheSidebar';

    static C_FARE_RULE = "cFareRule";
    static C_TC = "cTC";
    static C_SORT_DROPDOWN = "cSortDropDown";
    static C_IB_SORT_DROPDOWN = "cSortIbDropDown";
    static C_FILTER_TAG = "cFilterTag";
    static C_FILTER_AL_OB = "cFilterALOb";
    static C_FILTER_VIA_OB = "cFilterViaOb";
    static C_FILTER_STOPS_OB = "cFilterStopsOb";
    static C_ADD_ROLE = "cAddRole";
    static BOOKING_STATUS_PAGE = "bookingStatusPage";
    static C_ALL_FILTER_OB = "cAllFilterOb";
    static C_FILTER_PRICE_OB = "cFilterPriceOb";
    static C_FILTER_TIME_OB = "cFilterObDepTime";
    static C_FILTER_TIME_IB = "cFilterIbDepTime";
    static C_FILTER_DUR_OB = "cFilterDurOb";
    static C_FILTER_DUR_IB = "cFilterDurIb";
    static C_ALL_FILTER_IB = "cAllFilterIb";
    static C_FILTER_PRICE_IB = "cFilterPriceIb";
    static C_FILTER_AL_IB = "cFilterALIb";
    static C_FILTER_VIA_IB = "cFilterViaIb";
    static C_FILTER_STOPS_IB = "cFilterStopsIb";
    static C_EMPTY_FLIGHT_RESULT = "cEmptyFlightRes";
    static C_ML_FILTER_AL = "cMLFilterAL";
    static C_ML_FILTER_DUR = "cMLFilterDur";
    static C_ML_FILTER_TIME = "cMLFilterDepTime";
    static C_ML_FILTER_PRICE = "cMLFilterPrice";
    static C_ML_FILTER_VIA = "cMLFilterVia";
    static C_ML_ALL_FILTER = "cMLAllFilter";
    static C_ML_FILTER_TAG = "cMLFilterTag";
    
    static C_ML_FLIGHTRESULTCARD = "cMLFlightResCard";
    
    static C_ML_EMPTYFILTER = "cMLEmptyFilter";
    static ML_FLIGHTRESULTS = "MLFlightResults";
    static C_ML_SORT_DROPDOWN = "cMLSortDropDown";

    static C_RESERVATION_ID_SEARCH_MODAL = "cReservationIdSearchModal";
    static C_AGENT_DETAILS = "cAgentDetails";
    static C_AGENT_BALANCE_DETAIL = "cAgentBalanceDetail";
    static C_LOGIN_INFO = 'cLoginInfo'
    static C_PAYMENT_STATUS = 'cPaymentStatus'

    static C_RANGE_SLIDER = "cRangeSlider"
    static C_ALL_FILTER = "cAllFilter";

    static C_ALL_FILTER_HOTEL = "cAllFilterHotel";
    static C_FILTER_STAR = "cFilterStar";


    static MY_BOOKING_DETAIL = "MyBookingDetail";
    static TICKETING_QUEUE_DETAIL = "TicketingQueueDetail";
    static MY_BOOKING = "MyBookingPage";
    static TICKETING_QUEUE = "TicketingQueuepage";
    static PENDING_APPROVAL = "PendingApproval";
    static POSTPAID = "postpaid";
    static DEPOSIT = "Deposit";
    static PENDING_INVOICES = "PendingInvoices";
    static VIEW_STATEMENTS = "ViewStatements";
    static AGENT_VIEW_STATEMENTS = 'AgentViewStatements'
    static C_TICKETING_QUEUE = "cTicketingQueue";
    static C_TICKETING_DETAIL = 'cTicketingDetail';
    static RESET_PASSWORD = 'ResetPassword';

    static PAYMENT_STATUS = 'PaymentStatus';
    static SUCCESS_PAY = 'SuccessPay';
    static FAILED_PAY = 'FailedPay';
    static PENDING_PAY = 'PendingPay';
    static REFUND= 'Refund';
    static EXCHANGE ='Exchange'
    static C_FULLSCREEN = 'cFullScreen';
    static C_HELP_TIP = 'cHelpTip';
    static C_TICKETING_CONNECTION_FLIGHT = 'cTicketingConnectionFlight';
    static C_TABLE = "cTable";

    static NOTIFICATION_SETUP = 'NotificationSetUp'

    ///mobile
    static APROFILE = 'aProfile'

    static ADD_PROFILE = 'AddProfile';
    static PROFILE_LIST = 'ProfileList';
    static PAYMENT_RECEIVED = 'PaymentReceived';

    static C_HOTEL_LIST_VIEW='cHotelListView';
    static C_HOTEL_GRID_VIEW='cHotelGridView';
    static SUPPLIER_GROUP_ALL = 'SupplierGroupAll';
    static SUPPLIER_GROUP_NEW = 'SupplierGroupNew';
    static MANAGE_ALL = 'ManageAll';
    static MANAGE_HOTEL_NEW = 'ManageHotelNew';
    static C_REVIEW_HOTEL ='cReviewHotel'
    static TARIFF_ALL = 'TariffAll'
    static RATE_PLAN_ALL = 'RatePlanAll'
    static CANCELLATION_ALL = 'CancellationAll'
    static SURCHARGE_ALL = 'SurchargeAll'
    static TARIFF_NEW = 'TariffNew'
    static RATE_PLAN_NEW  = 'RatePlanNew'
    static CANCELLATION_NEW  = 'CancellationNew'
    static SURCHARGE_NEW  = 'SurchargeNew'
    static C_HOTEL_SELECTION ='cHotelSelection'
    static C_ROOM_INFO_BOX ='cRoomInfoBox'
    
    static  HOTEL_USERS_NEW='HotelUserNew'
    static  HOTEL_USERS_ALL='HotelUsersAll'

    static MARKUP_ALL = 'MarkupAll';
    static MARKUP_NEW = 'MarkupNew';
    static C_RICHTEXT_EDITOR = 'cRichTextEditor';

    static C_MONTH_DROPDOWN="cMonthDropDown";

    static C_BOOKING_MANIFEST_REPORT = "BookingManifestReport"
    static C_BOOKING_LIST_REPORT = "BookingListReport"
    static C_FLIGHT_LOAD_FACTOR_REPORT = "FlightLoadFactorReport"
    static C_FLIGHT_LEG_WITH_PAX="cFlightLegWithPax";
    
    static  CREATE_SIMPLE_PRICING ='createSimplePricing'
   

    
}
export class PRICING_CLASS_STATUS {
    static UP = '+';
    static DOWN = '-';
    static PERCENTAGE = 'P';
    static PER_TICKET = 'PT';
    static FIXED_AMOUNT = 'FA';
    static PER_BOOKING = 'PB';


}

export class BREADCRUMB_STATUS {
    static BREADCRUMB_ITEM = "bcItem";
    static PRESENT_ITEM = "current";
    static PAST_ITEM = "past";
}

export class TRIP {
    static ONE_WAY = 1;
    static ROUND_TRIP = 2;
    static MULTI_CITY = 3;
    static OW = 'OW';
    static RT = 'RT';

}
export class MANAGE_COLUMNS {
    static LOCK = 1;
    static VISIBLE = 2;
    static INVISIBLE = 0;
    
}
export class SORT {
    static LOWEST_PRICE = "LP";
    static HIGHEST_PRICE = "HP";
    static EARLIEST_DEP = "ED";
    static EARLIEST_ARR = "EA";
    static SHORTEST_DUR = "SD"
}
export class FILTERSTOPS {
    static ANY_NO_OF_STOPS = "ANoS";
    static NO_STOPS = "NS";
    static ONE_OR_FEW_STOPS = "OS";
    static TWO_OR_FEW_STOPS = "TS";

}
// export class CABIN_TYPE {
//     static  ECONOMY = 'ECONOMY';
//     static BUSINESS = 'BUSINESS'
// }
export class DEP_AIRPORTS {
    static  ALL_AIRPORTS = 'ALLAIRPORTS';
    static CUSTOM = 'CUSTOM'
}
export class TRANSACTION_TYPE {
    static  Postpaid_Booking=3;
    static Prepaid_Booking  =23;
    static Postpaid_Credit =1;
    static Postpaid_Debit  =2;
    static Prepaid_Credit =21;
    static Prepaid_Debit  =22;
    static Postpaid_Payment=4;
    static Prepaid_Topup =24

}

export class ORDER {
    static ASC = "asc";
    static DESC = "desc";
}

export class CITIZEN {
    static MYANMAR = {
        name: "Myanmar citizen",
        code: "MM"
    };
    static FOREIGNER = {
        name: "Foreigner",
        code: "F"
    };
    static CANADIAN = {
        name: "Canadian citizen",
        code: "CA"
    }
}
export class TOAST_TYPE {
    static INFO = "info";
    static SUCCESS = "success";
    static ERROR = "error";
    static CLEAR = "clear";
    static SHOW = "show";
}
export class BOUND_TYPE {
    static IB = "ibFlight";
    static OB = "obFlight";

}

export class PAX_COUNT {
    static MIN_ADULT = 1;
    static MAX_ADULT = 9;
    static MAX_CHILD = 9;
    static MAX_INFANT = 9;
}


export class APPROVEAGENT {
    static PREPAID = 1;
    static POSTPAID = 2;
}
export class AGENT_TYPE {
    static PREPAID = 1;
    static POSTPAID = 2;
}

export class DEFAULT_DROPDOWN_STATUS {
    static ALL = 'All';
    static ACTIVE = "Active";
    static INACTIVE = 'Inactive';

}


export class DEFAULT_PRICING {

    static  TYPE= 'PERC'
    static  CATEGORY='DOWN'
    static  APPLICABLE= 'PERBOOK'
    static  AMOUNT= 0

}


export class DATE_TIME_FORMAT {

    static  DEFAULT_DATE_FORMAT='DD-MMM-YYYY';
    static  API_DATE_FORMAT='YYYY-MM-DD'
    static DEFAULT_DATE_TIME_FORMAT='DD-MMM-YYYY HH:mm:ss'
    static DEFAULT_TIME_FORMAT='HH:mm'
    static  DATE_TIME_MINS='DD-MMM-YYYY HH:mm'
    static DAY_MONTH ='ddd, DD MMM'
    static DATE_TIME_MERIDIAN="DD-MMM-YYYY HH:mm A"
    static DATE_PICKER_FORMAT='dd-MMM-yyyy'
    static MONTH_DATE='MMM DD'
    static MONTH_DATE_YEAR='MMM DD, YYYY'
    static DAY_DATE_MONTH='ddd, DD MMM'

    static FULL_DATE_DAY ='ddd, DD MMM YYYY'

    static REPORT_DATE_FORMAT ='D-MMM-YYYY'




    
    //static DATE_MONTH_FORMAT="DD-MMM-YYYY"
}
export class PAYMENT_PROVIDER_GROUP {
    static systemPayment={
        groupId:"SYSTEMPAYMENT",
    }
    static cc={
        groupId:"CC",
    }
    static cashSales={
        groupId:"CASHSALES",
        providerType:{
          cash:'A24.Cash.Cash',
          bankTransfer:'A24.Cash.BankTransfer',
          officeExpense:'A24.Cash.OfficeExpense'   
        },
      };
      static creditSales={
        groupId:"CREDITSALES",
        providerType:{
          credit:'A24.Credit.Credit'  
        },
      }
}


export class PRICING_VALUE {
    static PER_PASSENGER = 'PERPAX';
    static PER_BOOKING = 'PERBOOK';
    static PERCENTAGE = 'PERC';
    static FIXED_AMOUNT = 'FIX';
    static MARK_UP = 'UP';
    static MARK_DOWN = 'DOWN';
}
export class LOCAL_STORAGE_KEYS {
    // static B2B_ADMIN_MF='b2b_admin_mf'
    // static B2B_ADMIN_AZ='b2b_admin_az'
    static B2B_ADMIN='b2b_admin_'
    static LANG = 'language';
    static LOG_COUNT = "logCount"
    static agent_jwt = 'agent_jwt'
    static sys_jwt = 'sys_jwt'
    static MULTIPLE_ERROR = 'multiple_error'
    static FLIGHT_SEARCH_HISTORY = "searchHistory"
    static HOTEL_SEARCH_HISTORY = "hotelSearchHistory"


    static B2B_VERSION ='b2b_version_'
    // static B2B_MF_VERSION = "b2b_mf_version"
    // static B2B_AZ_VERSION = "b2b_az_version"
    static B2B_USER_ID  = " b2b_userid_"
    // static B2B_MF_USER_ID = "b2b_mf_version_userid"

    // static B2B_AZ_USER_ID = "b2b_az_version_userid"



    static REPORT_TYPE = "reportType"
    static IS_INTRO_VISITED = "isIntroVisited"
    static LIST_MANAGE_COLUMNS = "manageTable"
    static BASE_SETTINGS='base_settings'
    static FORCE_CLEAR_VERSION= "forceClearVersion"


}
export class ROUTER_PARAM {


    static BOOKING_ORDER_ID='orderId'
    static PAYMENT_HISTORY='ph'
    static PAYMENT_DEBUG_URL = "debugurl"
    static SESSION_ID = "s";
    static PARAM = "param";
    static PROVIDER_ID = "providerid";
    static ORDER_PAYMENT_ID = "orderpaymentid";
    static TOKEN = "token";
    static SESSION = "sessionid";
    static CODE = "c";
    static VALUE = "v";
    static STATUS = "status";
    static ERROR = "error";
    static AUTHTOKEN = "authToken";
    static HOTEL_ID='hotelid';
    static ROOM_ID='roomid';
}
export class FLIGHT_SCHEDULE_STATUS {
    static ACTIVE = 1;
    static DEACTIVATED = 0;
    static PAUSE_SELLING = 2;
    }

export class PAX {
    static ADULT = "ADT";
    static CHILDREN = "CHD";
    static INFANT = "INF";
    static CONTACT = "Contact";
}

export class PAX_TITLE {
    static ADT = {
        MR: "Mr",
        MRS: "Mrs",
        MISS: "Miss",
        MSTR: "Master"
    }
    static CHD = {
        MISS: "Miss",
        MSTR: "Master"
    }
    static INF = {
        MISS: "Miss",
        MSTR: "Master"
    }

}



export class ALERT_MODAL_STATUS {
    static SUCCESS = 1;
    static INFO = 2
    static FAIL = 0
}

export class SECTOR_TYPE {
    static ALL = 'ALL';
    static DOM = 'DOM';
    static INT = 'INT';
}
export class ID_TYPE {
    static PASSPORT = "PP";
    static NRIC = "ID";

}
export class FILTER {
    // static  C_FILTER_AL_OB= "AL_OB";
    // static C_FILTER_PRICE_OB="PRI_OB";
    // static C_FILTER_STOPS_OB="STOP_OB";
    // static  C_FILTER_AL_IB= "AL_IB";
    // static C_FILTER_PRICE_IB="PRI_IB";
    // static C_FILTER_STOPS_IB="STOP_IB";
    static C_FILTER_AL = "al";
    static C_FILTER_PRICE = "price";
    static C_FILTER_STOPS = "stops";
    static C_FILTER_DUR = "totalDuration";
    static C_FILTER_TIME = "time";
    static C_FILTER_VIA = "via";
    static C_FILTER_DEPTIME = "depTime";
    static SOFTLIMIT_VAL = 0.5;
    static C_FILTER_STAR = "star";



}
export class AGENT_REGISTRATION_STATUS {
    static PENDING = 1;
    static APPROVED = 2;
    static REJECTED = 3;

}

export class POSTPAID_TYPE {
    static WEEKLY = 1;
    static ONCE_A_WEEK = 2;
    static MONTHLY = 3;

}
export class PROCEED_TO_TYPE {
    static HOLD_PAGE = "HOLDPAGE";
    static FLIGHT_RESULTS_PAGE = "FLIGHTRESULTSPAGE";
    static PAYMENT_GATEWAY = "PAYMENTGATEWAYHOLDPAGE";
    static TICKET_SUCCESS_PAGE = "TICKETSUCCESSPAGE";
}


export class PAYMENT_PROCEED_TO {
    static ERROR_PAGE = "ERRORPAGE";
    static SUCCESS_PAGE = "SUCCESSPAGE";
    static PENDING_PAGE = "PENDINGPAGE";
    static PAYMENT_PAGE = "FAILED-PAYMENTSELECTPAGE";
}

export class BOOKING_PAYMENT_STATUS {
    static SUCCESS = 0;
    static ERROR = 1;
}


export class BOOKING_PAYMENT_ERRORS {
    static ERRORS = {
        NO_ERROR: 0,
        JWT_TOKEN_EXPIRED: 1,
        TIMED_OUT: 2,
        API_ERROR: 3,
        SESSION_ID_NOT_RECEIVED: 4,
        PROVIDER_ID_NOT_RECEIVED: 5,
        JWT_TOKEN_NOT_RECEIVED: 6,
        ORDER_PAYMENT_ID_NOT_RECEIVED: 7,
        UNKNOWN_ERROR: 8,
        ENTRY_PAGE_CREATED_HOOK_ERROR: 9,
        ERROR_ON_SENDING_DATA_TO_PAYMENT_GATEWAY: 10,
        UNKNOWN_PAYMENT_GATEWAY_PROVIDER: 11,
        NO_QUERY_PARAMETERS_RECEIVED: 12,
        CANNOT_FIND_PAYMENT_GATEWAY_PROVIDER: 13,
        NO_RESPONSE_RECEIVED_FROM_PAYMENT_GATEWAY: 14,
        PAYMENT_FAILED: 15,
        PAYMENT_PENDING: 16,
        UNKNOWN_PAYMENT_STATUS_RECEIVED: 17,
        ERROR_WHILE_HANDLING_PAYMENT_RESPONSE: 18,
        ERROR_ON_2C2P_PAYMENT_FORM: 19,
        INVALID_JWT_TOKEN: 20,
        ORDER_TYPE_NOT_RECEIVED: 21,
        RECEIVED_INVALID_ORDER_TYPE: 22,
        RECEIVED_UNHANDLED_ORDER_TYPE: 23
    }
}

export class PAYMENT_FOR {
    static BOOKING_FLOW = "BookingFlow";
    static TICKET_NOW = "TicketNow";
    static TOPUP = "TopUp";
    static POSTPAID_TOPUP = "PostPaidTopUp";




}

export class PASSWORD_TYPE {
    static PASSWORD = "password";
    static TEXT = "text";
}


export class USERS_TYPE {
    static AGENT = 'agt'
    static SYSTEM = 'sys'
}


///  statement status for postpaid status 
// not to modify

export class POSTPAID_STATEMENT_STATUS {
    static NEW = 1
    static PARTIALLY_PAID = 2
    static PAID = 10
    static EMPTY = 15
    static ALL = [this.NEW, this.PARTIALLY_PAID, this.PAID, this.EMPTY]
    static DEPOSIT = [this.NEW, this.PARTIALLY_PAID]

}

export class GENDER {
    static MALE = "M";
    static FEMALE = "F"






}



export class REFUND_UPDATE_STATUS{


      static FAILED=0; 
      static  SUCCESS =1;
      static PROCESSING=2;

}


export class REFUND_ORDER_DET{

    static  ONLY_PROCESS=5
    static  SUCCESS_FAIL=7
    static SUCCESS = 10

}



export class REFUND_SEGMENT_STATUS{
  

    static TICKETED = 1
    static CHANGE_REQUESTED = 2
    static FULFILLED_SUCCESS = 10
    static FULFILLED_FAILURE = 11
}




export class BOOKING_ORDER_TYPE{

    static EXCHANGE =7;
    static REFUND=6;
    static BOOKING_ORDER=1;

}




export class BOOKING_STATUS {
    static HOLD = "Hold";
    static TICKETED_SUCCESS = "Ticketed success";
    static TICKETED_FAILURE = "Ticketed failure";
    static TICKET_PENDING = 11;
    static BOOKING_CANCELLED = 15;
    static HOLD_STATUS =7;
    static TICKETED_SUCCESS_STATUS = 10;
    static PAYMENT_STATUS_PENDING = 8;


 ///
    static BOOKING_ORDER = 1;
    static  REFUND_REQUESTED = 5;
    static REFUND_ORDER = 6;
    static hold = 7;
    static waiting_for_payment = 8;
    static fulfilled_success = 10;
    static fulfilled_failure = 11;
    static booking_cancelled = 15

    static PAYMENT_FAILED = 9;

}

export class LOGIN_PAGE {
    static AGENT = 'Agent'
    static SYSTEM = 'System'
}

export class AGENT_DB_REPORT_TYPE {
    static TODAY='TODAY'
    static THISWEEK='THISWEEK'
    static THISMONTH='THISMONTH'
    static CUSTOM='CUSTOM' 
}

export class TAX_TYPE {
    static DOMESTIC =1
    static INTERNATIONAL =2 
}

export class TAX_CABIN_TYPE {
    static BUSINESS ='BUS'
    static ECONOMY ="ECO"
}

export class TAX_AIRPORTS {
    static ALL_AIRPORTS ='ALLAIRPORTS'
    
}

export class SEARCH_OPTION {
        static FLIGHTS = 1;
        static HOTEL = 2;
   
}







export class NOTIFICATION_GROUP_ID
{
    static AGENTMGMT = "AGENTMGMT";
    static PAYMENT = "PAYMENT";
    static FLIGHT_REFUND_EXCHANGE = "FLIGHT_REFUND_EXCHANGE";
    static FLIGHT_BOOKING = "FLIGHT_BOOKING";
    static DEADLINE_NOTIFICATION = "DEADLINE_NOTIFICATION";
}
export class NOTIFICATION_TYPE_ID
{
    static AGENTREGISTRATION = 'AGENTREGISTRATION';
    static PREPAIDTOPUP = 'PREPAIDTOPUP';
    static POSTPAIDPAYMENT = 'POSTPAIDPAYMENT';
    static REFUNDREQUEST = 'REFUNDREQUEST';
    static EXCHANGEREQUEST = 'EXCHANGEREQUEST';
    static BOOKING = 'BOOKING';
    static TICKETING_DEADLINE_NOTIFICATION = "TICKETING_DEADLINE_NOTIFICATION";
}

export class NOTIFICATION_TYPE
{
    static Email = 'EMAIL';
    static Sms = 'SMS';
}

export class NOTIFICATION_APPLICABLE_TO
{
    static B2B = 'B2B';
    static B2C = 'B2C';
}


export class USER_ROLE_TYPE
{
    static  B2B_ROLE = 1
    static  SYSTEM_ROLE = 2
    static  HMS_ROLE = 3
}






export class HOTEL_INFO_TAB_IDS
{

    static AVAILABILITY=0
    static INFO=1
    static SETT=2
    static ROOM_SETT=3
    static AMENITIES=4
    static GALLERY=5
    static FACTS=6
    static SURCHARGE=7
    static TAX_SETT=8
    
    static ERROR=9

}


export class  SURCHARGE_TYPES
{
    static BREAK_FAST_PER_PAX = 'BreakfastPerPax'
    static EARLY_CHECKIN = 'Early_CheckIn'
    static LATE_CHECKOUT = 'Late_Checkout'
    static ROOM_SERVICE = 'RoomService'

}

export class  IMAGE_TYPES{
 static OPTIONS = {
     HILL_VIEW : 'Hill View',
     LOBBY : 'Lobby',
     MAIN_IMAGE : 'Hotel Main Image',
     PHOTO_GALLERY :'Photo Gallery',
     RESTAURANT : 'Restaurant',
     ROOM_TYPE :'Room Type Photo',
     HALL : 'Hall',
     BED_ROOM : 'Bed Room',
     GYM : 'Gym',
     SPORTS : 'Sports',
     ENTERTAINMENT : 'Entertainment',
     BAR : 'Bar/Lounge',
     POOL : 'Pool',
     AMENITIES : 'Amenities',
     EXTERIOR : 'Exterior',
     BUISNESS_CENTER : 'Business Center',
     GUEST_ROOMS : 'Guest Rooms',
 }
}

export class  ROOM_IMAGE_TYPES{
    static OPTIONS = {
        MAIN_IMAGE : 'Room Main Image',
        PHOTO_GALLERY :'Photo Gallery',
        ENTERTAINMENT : 'Entertainment',
        WINDOWS_VIEW : 'Windows view',
        AMENITIES : 'Amenities',
        BED_TYPES : 'Bed types',
        BATH_TOILETRIES : 'Bathroom and toiletries',
    }
   }

/*     export class CRS_BOOKING_STATUS{
     static OPTIONS = {
        
       BOOKED : 1,
      TICKETED : 2,
        FAILED : 3,
         HOLD: 4
     }
    } */ //this enum comes from api 

// export function genderList () {
//     let retValue=[];
// try {
//     retValue=[
//         {
//             code:"M",
//             name:"Male"
//         },
//         {
//             code:"F",
//             name:"Female"
//         }
//     ]
// } catch (err) {
//         let body = Logger.buildRequest(
//             genderList,
//           "error in genderList",
//           err.toString(),
//           "genderList",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//       return retValue;
